import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation.jsx';
import VisualizerView from './views/VisualizerView.jsx';

/**
 * Root application component.
 * Provides global navigation and routing between views.
 */
export default function App() {
    return (
        <>
            <Navigation />
            <Routes>
                <Route path="/" element={<VisualizerView />} />
                <Route path="/test" element={<div className="container" style={{ padding: '40px', color: '#ccc' }}>Test Yourself — Coming Soon</div>} />
            </Routes>
        </>
    );
}
